<template>
	<div class="grid">
		<template v-if="loader==true">
			<div class="col-12 mb-2 lg:col-12">
				<ProgressBar mode="indeterminate" style="height: .5em" />
			</div>
		</template>
		
		
		<template v-if="seway_exist==true">
			<template v-if="seway_custoer_exist==true">
				<template v-if="edit_name_customer==true">
					<div class="col-6 lg:col-6 mt-2">
						<span class="p-float-label">
							<InputText type="text" id="title" class="w-full" v-model="nameChecklist" :class="{'p-invalid': submitted && !nameChecklist}"/>
							<label for="title">NOMBRE DEL CHECKLIST*</label>
						</span>
					</div>
					<div class="col-4 lg:col-4 mt-2">
						<h4 class="mt-2">{{nameChecklist}}</h4>
					</div>
					<div class="col-2 lg:col-2 mt-2">
						<Button icon="pi pi-save" label="Guardar" :loading="loader" class="p-button-rounded button-sewayblue" @click="guardarNameCustomer" />
					</div>
				</template>
				<template v-else>
					<div class="col-12 lg:col-12 mt-1">
						<h4 class="mt-2">{{nameChecklist}}<i class="pi pi-pencil ml-3 cursor-pointer" title="EDITAR NOMBRE DEL CHECKLIST" @click="edit_name_customer = true"></i></h4>
					</div>
				</template>
				<div class="col-12 lg:col-12">
					<Fieldset legend="Nuevo" :toggleable="true" :collapsed="setstatus">
						<div class="grid p-fluid">
							<div class="col-12 lg:col-6">
								<div class="grid p-fluid">
									<div class="col-12 lg:col-6">
										<span class="p-float-label">
											<InputText type="text" id="title" class="w-full" v-model="frmInspeccion.title" :class="{'p-invalid': submitted && !frmInspeccion.title}"/>
											<label for="title">Titulo*</label>
										</span>
									</div>
									<div class="col-12 lg:col-6">
										<div class="flex align-items-center justify-content-center">
											<label for="masive">Activar como masivo*</label><br>
											
											<!-- <Checkbox v-model="frmInspeccion.masive" :trueValue="1" :falseValue="0" :binary="true" /> -->
										</div>
										<div class="flex align-items-center justify-content-center">
											<Checkbox v-model="frmInspeccion.masive" :trueValue="1" :falseValue="0" :binary="true" />
										</div>
										<!-- <span class="p-float-label"> -->
											<!-- <InputText type="text" id="title" class="w-full" v-model="frmInspeccion.title" :class="{'p-invalid': submitted && !frmInspeccion.title}"/> -->
											<!-- <Checkbox v-model="" :binary="true" /> -->
											
											<!-- <RadioButton inputId="masive" name="SI" :value="1" v-model="frmInspeccion.masive" />
											<RadioButton inputId="masive" name="NO" :value="0" v-model="frmInspeccion.masive" /> -->
										<!-- </span> -->
									</div>
								</div>

								<div class="grid p-fluid mt-2">
									<div class="col-12 lg:col-6">
										<span class="p-float-label">
											<InputText type="number" id="number_images" class="w-full" v-model="frmInspeccion.number_images" :class="{'p-invalid': submitted && !frmInspeccion.number_images}"/>
											<label for="number_images">Número de Fotos Permitidas*</label>
										</span>
									</div>
									<div class="col-12 lg:col-6">
										<span class="p-float-label">
											<InputText type="number" id="text" class="w-full" v-model="frmInspeccion.required_images" :class="{'p-invalid': submitted && !frmInspeccion.required_images}"/>
											<label for="text">Número de Fotos Obligatorias*</label>
										</span>
									</div>
								</div>
							</div>
							<div class="col-12 lg:col-6">
								<span class="p-float-label">
									<Textarea id="description" v-model="frmInspeccion.description" required="true" rows="4" cols="53" autofocus :class="{'p-invalid': submitted && !frmInspeccion.description}" />
									<label for="title">Descripción*</label>
								</span>
							</div>
							<div class="col-12 px-8">
								<!-- <Button icon="pi pi-save" title="Guardar" class="p-button-rounded button-sewayblue" :loading="loader" @click="guardar_eventos" />  -->
								<!-- <template v-if="editable==false"> -->
									<Button icon="pi pi-save" label="Guardar" :loading="loader_even" class="p-button-rounded button-sewayblue" @click="guardar_item" />
								<!-- </template>
								<template v-else>
									<Button icon="pi pi-pencil" label="Editar" :loading="loader_even" class="p-button-rounded button-sewayblue" @click="guardar_item" />
								</template> -->
							</div>
						</div>
						
						<!-- <p>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
							Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
						</p> -->
					</Fieldset>
				</div>
			</template>
			<template v-else>
				<template v-if="edit_name_customer==true">
					<div class="col-6 lg:col-6 mt-2">
						<span class="p-float-label">
							<InputText type="text" id="title" class="w-full" v-model="nameChecklist" :class="{'p-invalid': submitted && !nameChecklist}"/>
							<label for="title">NOMBRE DEL CHECKLIST*</label>
						</span>
					</div>
					<div class="col-4 lg:col-4 mt-2">
						<h4 class="mt-2">{{nameChecklist}}</h4>
					</div>
					<div class="col-2 lg:col-2 mt-2">
						<Button icon="pi pi-save" label="Guardar" :loading="loader" class="p-button-rounded button-sewayblue" @click="guardarNameCustomer" />
					</div>
				</template>
				<template v-else>
					<div class="col-8 lg:col-8 mt-2">
						Actualmente no cuentas con un nombre para su checklist<i class="pi pi-exclamation-triangle ml-2" style="font-size: 2rem"></i>
						<!-- <h4 class="mt-2"><i class="pi pi-plus ml-3 cursor-pointer" title="CREAR NOMBRE DEL CHECKLIST" @click="edit_name_customer = true"></i></h4> -->
						<!-- <Button icon="pi pi-plus" label="Crear Nombre" :loading="loader_even" class="p-button-rounded button-sewayblue" @click="edit_name_customer = true" /> -->
					</div>
					<div class="col-4 lg:col-4 my-3">
						<Button icon="pi pi-plus" label="Crear Nombre" :loading="loader_even" class="p-button-rounded button-sewayblue" @click="edit_name_customer = true" />
					</div>
				</template>
				<!-- <div class="col-12 lg:col-12">
					<h4>N</h4>
				</div> -->

			</template>
			
			<div class="col-12 lg:col-12">
				<!-- {{selectedProducts}} -->
				<!-- {{checklist_customer}} -->
				<DataTable ref="pagination" :value="checklist_customer" v-model:selection="selectedProducts" dataKey="id" :paginator="false" :rows="3" @paginate="onChangePage"
								:paginatorTemplate="'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'" selectionMode="single"
								:currentPageReportTemplate="'Showing '+pagination.from+' to '+pagination.to+' of '+pagination.total+' customers'" responsiveLayout="scroll">
									<Column field="title" header="Titulo" :sortable="false">
										<template #body="slotProps">
											<span class="p-column-title">title</span>
											{{slotProps.data.title}}
										</template>
									</Column>
									<Column field="description" header="Descripción" :sortable="false">
										<template #body="slotProps">
											<span class="p-column-title">description</span>
											{{slotProps.data.description}}
										</template>
									</Column>
									<Column field="photo_numbers" header="Número de Fotos Permitidas" :sortable="false">
										<template #body="slotProps">
											<span class="p-column-title">number_images</span>
											<!-- <template v-if="slotProps.data.editable==false"> -->
												{{slotProps.data.number_images}}
											<!-- </template>
											<template v-else>
												<InputNumber v-model="slotProps.data.number_images" :modelValue="slotProps.data.number_images" inputId="minmax" :min="0" :max="100" />
											</template> -->
										</template>
									</Column>
									<Column field="required_images" header="Número de Fotos Obligatorias" :sortable="false">
										<template #body="slotProps">
											<span class="p-column-title">required_images</span>
											<!-- <template v-if="slotProps.data.editable==false"> -->
												{{slotProps.data.required_images}}
											<!-- </template>
											<template v-else>
												<InputNumber v-model="slotProps.data.required_images" :modelValue="slotProps.data.required_images" inputId="minmax" :min="0" :max="100" />
											</template> -->
										</template>
									</Column>
									<Column field="masive" header="Es Masivo" :sortable="false">
										<template #body="slotProps">
											<span class="p-column-title">masive</span>
											<template v-if="slotProps.data.masive==1">
												SI
											</template>
											<template v-else>
												NO
											</template>
											<!-- {{slotProps.data.masive}} -->
										</template>
									</Column>
									<!-- <template v-if="editable==false"> -->
									<Column field="acciones" header="Acciones" :sortable="false" style="width: 8rem">
										<template #body="slotProps">
											<div class="flex flex-wrap gap-2">
												<!-- <template v-if="slotProps.data.editable==false"> -->
												<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded button-sewayblue mr-2" :loading="loader_even" @click="editar_item(slotProps.data)" /> 
												<Button icon="pi pi-trash" title="Eliminar" class="p-button-rounded button-orange" :loading="loader_even" @click="eliminar_evento(slotProps.data,slotProps.index)" /> 
												<!-- </template>
												<template v-else>
													<Button icon="pi pi-check" label="Confirmar" class="p-button-rounded button-sewayblue" :loading="loader_even" @click="editar_item(slotProps.index)" /> 
												</template> -->
											</div>
										</template>
									</Column>
									<!-- </template> -->
									<!-- <Column field="photo_required" header="Estado" :sortable="false">
										<template #body="slotProps">
											<span class="p-column-title">photo_required</span>
											<template v-if="slotProps.data.id==0">
												<Tag class="mr-2 text-orange" icon="pi pi-exclamation-triangle" value="Sin Guardar"></Tag>
											</template>
											<template v-else>
												<Tag class="mr-2 text-sewayblue" icon="pi pi-check" value="Guardado"></Tag>
											</template>
										</template>
									</Column> -->
								</DataTable>
				<div>
					<!-- <Paginator :v-model="pagination.current_page" :rows="pagination.per_page" :rowsPerPageOptions="[15]" :totalRecords="pagination.total" @page="onChangePage($event)"></Paginator> -->
					<Paginator :v-model:first="pagination.from" :rows="pagination.per_page" :rowsPerPageOptions="[15]" :totalRecords="pagination.total" @page="onChangePage($event)"></Paginator>
				</div>
				
			</div>
		</template>

		<template v-else>
			<div class="col-12 lg:col-12 align-items-center text-center mt-8">
			<img src="layout/images/widgets/feature-faq.svg" alt="feature-faq" width="400">
			<div class="mx-8 my-3">
				<h4>Su empresa actualmente no cuenta con nuestra App Seway-plus<br> comunicate con un comercial para tener la aplicación móvil.</h4>
			</div>
			<a href="https://wa.link/8ppwru" target="_blank"><Button icon="pi pi-whatsapp" label="Contactar Comercial" :loading="loader" class="p-button-rounded p-button-success" /></a>
			</div>
		</template>
		<Dialog v-model:visible="deleteTipoDespachoDialog" :style="{width: '450px'}" header="Eliminar Item" :modal="true">
			<div class="flex align-items-center justify-content-center">
				<i class="pi pi-exclamation-triangle mr-1" style="font-size: 2rem" />
				<ul>
					<li><p><b>Eliminar </b>Esta seguro de eliminar este item del checklist?</p></li>
				</ul>
			</div>
			<template #footer>
				<Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteTipoDespachoDialog = false"/>
				<Button id="buttoneliminar" label="Eliminar" icon="pi pi-check" :loading="loader_even" class="p-button-text" @click="deleteEvent" />
			</template>
		</Dialog>
	</div>
</template>

<script>
// import axios from 'axios'
import EventBus from '../../../event-bus';
export default {
	data() {
		return {
			message: [],
			generadores_seway: [],
			tipos_despachos: [],
			list_tdespachos_selected: [],
			frmInspeccion: {
				id: 0,
				title: '',
				description: '',
				number_images: '',
				required_images: '',
				masive: 0
			},
			generadores_table: [],
			rowsPerPage: 15, // Número de filas por página
			currentPage: 1, // Página actual
			totalRows: 0, 
			setstatus: true,
			selectgenerador: null,
			seway_exist: false,
			seway_custoer_exist: false,
			edit_name_customer: false,
			nameChecklist: '',
			deleteEventDialog: false,
			deleteTipoDespachoDialog: false,
			loader_table: false,
			editable: false,
			generadores: [],
			checklist_customer: [],
			loader: false,
			loader_gen: false,
			loader_even: false,
			submitted: false,
			pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			count: 0,
			selectedProducts: [],
			items: [
					{label: 'Update', icon: 'pi pi-fw pi-refresh'},
					{label: 'Edit', icon: 'pi pi-fw pi-pencil'}
				],
			ingresoCostumer: false
		}
	},
	created(){
		EventBus.on('traer-inspeccion', () => this.loadGeneradores());
	},
	mounted(){
		// this.loadGeneradores(1);
		// this.cargargeneradorescustomer(1);
	},
	methods:{
		onChangePage(page) {
				
				this.loadDataTable1((page.page+1),this.cartera);
		},
		paginate(event) {
			this.currentPage = event.page + 1;
			this.loadGeneradores(this.currentPage);
		},
		clearFrminspeccion(){
			this.frmInspeccion.id = 0;
			this.frmInspeccion.title = '';
			this.frmInspeccion.description = '';
			this.frmInspeccion.required_images = '';
			this.frmInspeccion.number_images = '';
		},
			// Función para cargar los datos de la tabla
		async loadGeneradores() {
			this.seway_exist = false;
			this.seway_custoer_exist = false;
			this.nameChecklist = '';
			const cookieName = 'Email';
				const IdRol = 'IdRol';
				this.loader = true;
				let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
				var email = cookie[cookieName];
				var id_rol = cookie[IdRol];
			// this.cleartable();
			this.loader = true;
			var _that = this;
			this.checklist_customer = [];
			this.clearFrminspeccion();
                window.api.call('post', '/cargar_inspeccion_vehicular', {email: email,id_rol: id_rol}).then( function(response) {
                    if(response.status == 200){
						console.log(response.data.existe_seway);
						if(response.data.existe_seway == false){
							_that.seway_exist = false;

						}else{
							_that.seway_exist = true;
							if (response.data.existe_customer>0) {
								_that.seway_custoer_exist = true;
								_that.edit_name_customer = false;
								_that.nameChecklist = response.data.customer[0].description;
							}
							_that.checklist_customer = response.data.data;
							console.log(response.data.data);
						}
						
						_that.loader = false;
						_that.editable = false;
						
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		},
		editNameCustomer(){
			if (condition) {
				
			}
		},
		guardarNameCustomer(){
			if(this.nameChecklist==''){
				this.loader = false;
				this.submitted = true;
				this.$toast.add({severity:'error', summary: 'Falta información', detail:'Debes ingresar un nombre para su checklist', life: 4000});
				return
			}
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			
			window.api.call('post', '/guardar_name_checklist', {email: email,id_rol: id_rol,namechecklist: this.nameChecklist}).then( function(response) {
				if(response.status == 200){
					_that.checklist_customer = response.data.data;
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se Guardo el Nombre del checklist con exito', life: 6000 });
					_that.clearFrminspeccion();
					if(response.data.existe_seway == false){
						_that.seway_exist = false;

					}else{
						_that.seway_exist = true;
						if (response.data.existe_customer>0) {
							_that.seway_custoer_exist = true;
							_that.edit_name_customer = false;
							_that.nameChecklist = response.data.customer[0].description;
						}
						_that.checklist_customer = response.data.data;
						console.log(response.data.data);
					}
						
						_that.loader = false;
						_that.editable = false;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader_even = false;
				_that.loader = false;
				this.$toast.add({severity:'error', summary: 'Ocurrio un error al guardar', detail:'Favor informar a un admin', life: 6000});
			});
		},
		guardar_item(){
			
			if(this.frmInspeccion.title=='' || this.frmInspeccion.number_images=='' || this.frmInspeccion.required_images==''|| this.frmInspeccion.description==''){
				this.loader = false;
				this.submitted = true;
				this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor ingresar todos los campos', life: 4000});
				return
			}
			if (this.frmInspeccion.required_images > this.frmInspeccion.number_images) {
				this.$toast.add({severity:'error', summary: 'Cantidad requerida incorrecta', detail:'El valor requerido debe ser inferior o igual al permitido', life: 4000});
				return
			}
			this.loader_even = true;
			// console.log('si diooooj mioo');
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			
			window.api.call('post', '/guardar_item_checklist', {email: email,id_rol: id_rol,frmInspeccion: this.frmInspeccion}).then( function(response) {
				if(response.status == 200){
					_that.checklist_customer = response.data.data;
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se Guardo el item con exito', life: 6000 });
					_that.clearFrminspeccion();
					_that.editable = false;
					_that.setstatus = true;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader_even = false;
				this.$toast.add({severity:'error', summary: 'Ocurrio un error al guardar', detail:'Favor informar a un admin', life: 6000});
			});
		},
		editar_item(data){
			this.editable = true;
			this.setstatus = false;
			this.frmInspeccion.id = data.id;
			this.frmInspeccion.title = data.title;
			this.frmInspeccion.description = data.description;
			this.frmInspeccion.number_images = data.number_images;
			this.frmInspeccion.required_images = data.required_images;
			this.frmInspeccion.masive = data.masive;
			this.selectedProducts = data;
		},
		eliminar_evento(data,index){
			// console.log(data);
			// console.log(index);
			
			// if (data.id==0) {
			// 	this.eventos[index_eventos].eventos.splice(index,1);
			// 	this.$toast.add({severity:'success', summary: 'Eliminado correctamente', detail:'Los Eventos con estado Sin Guardar se eliminan sin confirmación', life: 5000});
			// }else{
				localStorage.setItem('id_item',data.id);
				// localStorage.setItem('idx_tipo_despacho',index);
				localStorage.setItem('idx_item',index);
				this.deleteTipoDespachoDialog = true;
				// localStorage.getItem("idx_factura_elimiada")
			// }
			
		},
		deleteEvent(){
			const id_item = localStorage.getItem("id_item");
			const idx_item = localStorage.getItem("idx_item");
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.loader_even = true;
			window.api.call('post', '/eliminar_item_checklist', {email: email,id_rol: id_rol,id_item: id_item,nit_generador: this.nit_generador}).then( function(response) {
				if(response.status == 200){
					_that.checklist_customer.splice(idx_item,1);
					_that.deleteTipoDespachoDialog = false;
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Eliminado correctamente', detail: 'Puedes volver agregarlo en cualquier momento', life: 6000 });
				}
			}).catch(function (err) {
				console.log(err);
				_that.deleteTipoDespachoDialog = false;
				_that.loader_even = false;
			});
		},
	},
	computed: {
			isRTL() {
				return this.$appState.RTL;
			}
		}
}
</script>

<style scoped>
.button-orange{
    background: #EB7D10;
    color: white;
}
.text-orange{
    background: white;
    color: #EB7D10;
	border: 1px solid #EB7D10;
}
.button-sewayblue{
    background: #0A354E;
    color: white;
}
.text-sewayblue{
    background: white;
    color: #0A354E;
	border: 1px solid #0A354E;
}
/* HOVERS */
.button-orange:hover{
    background: #d54000;
    color: white;
}
.text-orange:hover{
    background: white;
    color: #d54000;
	border: 1px solid #d54000;
}
.button-sewayblue:hover{
    background: #0c4f77;
    color: white;
}
.text-sewayblue:hover{
    background: white;
    color: #0c4f77;
	border: 1px solid #0c4f77;
}
</style>
